import { Expose, } from 'class-transformer';
import { ImageFileData } from './ImageFileData';
import { Model } from './Model';

export class SocratesImage extends Model {

	constructor(json: any = null) {
		super(json);
		this._timeCreated = Date.now();

		if (json && json.url) {
			this._url = json.url;
		} else {
			this._url = '';
			this._isNew = true;
		}
		if (json) {
			this._height = json.h || json.height || 0;
			this._width = json.w || json.width || 0;
			this.setDisplaySizes();
		}
		this._imageData = new ImageFileData();
	}

	private _displayHeight = 0;
	@Expose()
	set displayHeight(newValue: number) { this._displayHeight = newValue; }
	get displayHeight(): number { return this._displayHeight; }

	private _displayWidth = 0;
	@Expose()
	set displayWidth(newValue: number) { this._displayWidth = newValue; }
	get displayWidth(): number { return this._displayWidth; }

	private _height = 0;
	@Expose()
	get height(): number { return this._height; }
	set height(newHeight: number) {
		this._height = newHeight;
		this.setDisplaySizes();
	}

	private _imageData: ImageFileData = new ImageFileData();
	@Expose()
	set imageData(newValue: ImageFileData) { this._imageData = newValue; }
	get imageData(): ImageFileData {
		if (!this._imageData) {
			this._imageData = new ImageFileData();
		}
		return this._imageData;
	}

	private _timeCreated = 0;
	@Expose()
	set timeCreated(newValue: number) { this._timeCreated = newValue; }
	get timeCreated(): number { return this._timeCreated; }

	private _url: string;
	@Expose()
	set url(newValue: string) { this._url = newValue; }
	get url(): string { return this._url; }

	private _width = 0;
	@Expose()
	get width(): number { return this._width; }
	set width(newWidth: number) {
		this._width = newWidth;
		this.setDisplaySizes();
	}

	get hasImage(): boolean {
		return this._imageData?.hasImage ?? false;
	}

	hasValidUrl(): boolean {
		return !!this._url && this._url.length > 0;
	}

	// A SocratesImage is "new" when it has not yet been persisted (no URL assigned).
	override isNew(): boolean {
		return this._isNew && !this.hasValidUrl();
	}

	private setDisplaySizes() {
		this._displayHeight = this._height;
		this._displayWidth = this._width;

		let ratio = 0;
		if (this._height > this._width) {
			if (this._height > 400) {
				ratio = 400 / this._height;
				this._displayHeight = 400;
				this._displayWidth = this._width * ratio;
			}
		} else if (this._width > 400) {
			ratio = 400 / this._width;
			this._displayHeight = this._height * ratio;
			this._displayWidth = 400;
		}
	}
}
